import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { blogs as BLOGS_URL, blogdelete as BLOG_DELETE_URL } from './proxyurls'; 
import EditBlog from './EditBlog'; 
import AddBlog from './AddBlog'; 
import { useNavigate } from 'react-router-dom';
import Layout from './layout';

function ManageBlogs() {
  const [blogs, setBlogs] = useState([]);
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [editBlogId, setEditBlogId] = useState(null); 
  const [addingBlog, setAddingBlog] = useState(false); 
  const [currentPage, setCurrentPage] = useState(1); 
  const [successMessage, setSuccessMessage] = useState(''); 
  const [filterTitle, setFilterTitle] = useState(''); 
  const recordsPerPage = 12; 
  const navigate = useNavigate(); 

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(BLOGS_URL); 
        const blogsData = Array.isArray(response.data.blogs) ? response.data.blogs : [];
        setBlogs(blogsData); 
        setFilteredBlogs(blogsData);
      } catch (error) {
        console.error('Error fetching blog data:', error);
        setBlogs([]);
        setFilteredBlogs([]);
      }
    };

    fetchBlogs();
  }, []);

  useEffect(() => {
    if (!Array.isArray(blogs)) {
      setFilteredBlogs([]);
      return;
    }
    
    if (filterTitle.trim() === '') {
      setFilteredBlogs(blogs);
    } else {
      const filtered = blogs.filter(blog => 
        blog && blog.title && blog.title.toLowerCase().includes(filterTitle.toLowerCase())
      );
      setFilteredBlogs(filtered);
    }
    setCurrentPage(1);
  }, [filterTitle, blogs]);

  useEffect(() => {
    const successMessage = localStorage.getItem('successMessage');
    if (successMessage) {
      setSuccessMessage(successMessage);
      localStorage.removeItem('successMessage');
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    }
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm('Are you sure you want to delete this blog?');
    if (!confirmDelete) return;

    try {
      await axios.delete(BLOG_DELETE_URL(id));
      const updatedBlogs = Array.isArray(blogs) ? blogs.filter((blog) => blog.id !== id) : [];
      const updatedFilteredBlogs = Array.isArray(filteredBlogs) ? filteredBlogs.filter((blog) => blog.id !== id) : [];
      setBlogs(updatedBlogs);
      setFilteredBlogs(updatedFilteredBlogs);
      setSuccessMessage('Blog deleted successfully');
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000);
    } catch (error) {
      console.error('Error deleting blog:', error);
    }
  };

  const handleEdit = (id) => {
    navigate(`/edit-blog/${id}`); 
  };

  const handleCancelEdit = () => {
    setEditBlogId(null); 
  };

  const handleSaveEdit = () => {
    setEditBlogId(null); 
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(BLOGS_URL); 
        const blogsData = Array.isArray(response.data) ? response.data : [];
        setBlogs(blogsData); 
        setFilteredBlogs(blogsData);
      } catch (error) {
        console.error('Error fetching blog data:', error);
        setBlogs([]);
        setFilteredBlogs([]);
      }
    };
    fetchBlogs();
  };

  const handleAdd = () => {
    navigate('/add-blog'); 
  };

  const handleCancelAdd = () => {
    setAddingBlog(false); 
  };

  const handleSaveAdd = () => {
    setAddingBlog(false); 
    const fetchBlogs = async () => {
      try {
        const response = await axios.get(BLOGS_URL); 
        const blogsData = Array.isArray(response.data) ? response.data : [];
        setBlogs(blogsData); 
        setFilteredBlogs(blogsData);
      } catch (error) {
        console.error('Error fetching blog data:', error);
        setBlogs([]);
        setFilteredBlogs([]);
      }
    };
    fetchBlogs();
  };

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const safeFilteredBlogs = Array.isArray(filteredBlogs) ? filteredBlogs : [];
  const currentRecords = safeFilteredBlogs.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(safeFilteredBlogs.length / recordsPerPage);

  return (
    <>
      <Layout>
        <div style={{ padding: '8px' }}>
            <section className="w-100 p-3">
              <div className="row border-bottom pb-2 mb-3">
                <div className="col-md-8">
                  <h4>Manage Blogs</h4>
                </div>
                <div className="col-md-4 text-end">
                  <button
                    type="button"
                    className="btn btn-outline-success btn-sm"
                    style={{ marginLeft: 'auto' }}
                    onClick={handleAdd}
                  >
                    Add Blog
                  </button>
                </div>
              </div>
              {successMessage && (
                <div className="alert alert-success" role="alert">
                  {successMessage}
                </div>
              )}
              {addingBlog ? (
                <AddBlog
                  onCancel={handleCancelAdd}
                  onSave={handleSaveAdd}
                />
              ) : editBlogId ? (
                <EditBlog
                  blogId={editBlogId}
                  onCancel={handleCancelEdit}
                  onSave={handleSaveEdit}
                />
              ) : (
                <div className="datatable">
                  <div className="row mb-3">
                    {/* <div className="col-md-4">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Filter by title..."
                        value={filterTitle}
                        onChange={(e) => setFilterTitle(e.target.value)}
                      />
                    </div> */}
                  </div>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th style={{ padding: '13px', width:'20%' }}>Title</th>
                          <th style={{ padding: '13px' }}>Slug</th>
                          <th style={{ padding: '13px' }}>Status</th>
                          <th style={{ padding: '13px' }}>Created At</th>
                          <th style={{ padding: '13px', width:'13%' }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRecords.length > 0 ? (
                          currentRecords.map((blog) => (
                            <tr className='table_list' key={blog.id}>
                              <td>{blog.name || 'N/A'}</td>
                              <td>{blog.slug || 'N/A'}</td>
                              <td>
                                <span className={`badge rounded-pill ${blog.status === 0  ? 'bg-success' : 'bg-info'}`}>
                                  {blog.status === 0 ? 'Published' : 'Draft'}
                                </span>
                              </td>
                              <td>{blog.created_at ? new Date(blog.created_at).toLocaleDateString() : 'N/A'}</td>
                              <td>
                                <div className='btn-group'>
                                  <button
                                    type="button"
                                    className="btn btn-outline-warning"
                                    data-mdb-ripple-init=""
                                    data-mdb-ripple-color="dark"
                                    onClick={() => handleEdit(blog.id)}
                                    title='Edit'
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    data-mdb-ripple-init=""
                                    data-mdb-ripple-color="dark"
                                    onClick={() => handleDelete(blog.id)}
                                    title='Delete'
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6">No blogs available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="datatable-pagination d-flex justify-content-end">
                    <div className="datatable-pagination-buttons">
                      <button
                        className="btn btn-link datatable-pagination-button datatable-pagination-left"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        <i className="fa fa-chevron-left" />
                      </button>
                      <span>{currentPage} of {totalPages}</span>
                      <button
                        className="btn btn-link datatable-pagination-button datatable-pagination-right"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(currentPage + 1)}
                      >
                        <i className="fa fa-chevron-right" />
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </section>
        </div>
      </Layout>
    </>
  );
}

export default ManageBlogs;
